const BASE = '/normas';

export const ACTIVITY_NORMS = {
  'Minigolf': {
    cartel: `${BASE}/cartel-minigolf.png`,
    cartelPdf: `${BASE}/cartel-golf-terrestre.pdf`,
    stats: [
      { label: 'Edad', value: 'Todas las edades' },
      { label: 'Circuito', value: '9 hoyos' },
      { label: 'Fianza', value: '5 € por palo' },
    ],
    rules: [
      { ok: true,  text: 'Palo siempre por debajo de la cintura' },
      { ok: true,  text: 'Respeta tu turno y avanza hoyo a hoyo' },
      { ok: false, text: 'No swing alto ni corras por el circuito' },
      { ok: false, text: 'No uses el palo cerca de otras personas' },
    ],
    footer: 'Menores acompañados de un adulto. Fianza de 5 € por palo devuelta al terminar.',
  },
  'El Club de Manri': {
    cartel: `${BASE}/cartel-terrestre.png`,
    cartelPdf: `${BASE}/cartel-golf-terrestre.pdf`,
    stats: [
      { label: 'Edad', value: '3 a 13 años' },
      { label: 'Aforo', value: '8–10 niños' },
      { label: 'Horario', value: 'Mañana 10:30–13:00 · Tarde 15:00–17:30' },
    ],
    rules: [
      { ok: true,  text: 'Acceso descalzo (sin zapatos ni calcetines)' },
      { ok: true,  text: 'Tobogán de uno en uno, sin prisas' },
      { ok: false, text: 'No gafas, comida, bebida ni chicle' },
      { ok: false, text: 'No empujes, no hagas volteretas ni escales paredes' },
    ],
    footer: 'Zona supervisada por monitor. Menores de 7 años acompañados de un adulto.',
  },
};

export const FREE_ACCESS_ACTIVITIES = [
  {
    id: 'castillo-terrestre',
    title: 'Castillo Terrestre',
    subtitle: 'Castillo Hinchable · Zona exterior de la Ludoteca',
    normsKey: 'castillo-terrestre',
  },
  {
    id: 'castillo-acuatico',
    title: 'Castillo Acuático',
    subtitle: 'Castillo Hinchable · Piscina de La Cascada',
    normsKey: 'castillo-acuatico',
  },
  {
    id: 'piraguas',
    title: 'Piraguas · Kayak',
    subtitle: 'Piscina de La Cascada',
    normsKey: 'piraguas',
  },
];

export const FREE_ACCESS_NORMS = {
  'castillo-terrestre': {
    cartel: `${BASE}/cartel-terrestre.png`,
    cartelPdf: `${BASE}/cartel-golf-terrestre.pdf`,
    stats: [
      { label: 'Edad', value: '3 a 13 años' },
      { label: 'Aforo', value: '8–10 niños' },
      { label: 'Horario', value: 'Mañana 10:30–13:00 · Tarde 15:00–17:30' },
    ],
    rules: [
      { ok: true,  text: 'Acceso descalzo (sin zapatos ni calcetines)' },
      { ok: true,  text: 'Tobogán de uno en uno, sin prisas' },
      { ok: false, text: 'No gafas, comida, bebida ni chicle' },
      { ok: false, text: 'No empujes, no hagas volteretas ni escales paredes' },
    ],
    footer: 'Zona supervisada por monitor. Menores de 7 años acompañados de un adulto.',
  },
  'castillo-acuatico': {
    cartel: `${BASE}/cartel-acuatico.png`,
    cartelPdf: `${BASE}/cartel-acuatico.pdf`,
    stats: [
      { label: 'Edad', value: '5 a 13 años' },
      { label: 'Estatura', value: 'Máx. 1,70 m' },
      { label: 'Aforo', value: '12 a la vez' },
      { label: 'Horario', value: '11:00–17:00' },
    ],
    rules: [
      { ok: true,  text: 'Acceso por turnos con autorización del monitor' },
      { ok: true,  text: 'Sube y baja de uno en uno, sin prisas' },
      { ok: true,  text: 'Indispensable saber nadar' },
      { ok: false, text: 'No empujes, no hagas el pino ni saltes encima de otros' },
      { ok: false, text: 'No gafas, relojes, hebillas ni objetos punzantes' },
    ],
    footer: 'Actividad supervisada en todo momento. Abandona el hinchable al primer aviso del monitor.',
  },
  'piraguas': {
    cartel: `${BASE}/cartel-piraguas.png`,
    cartelPdf: `${BASE}/cartel-piraguas.pdf`,
    stats: [
      { label: 'Edad', value: '5 a 13 años' },
      { label: 'Turnos', value: '8–10 minutos' },
      { label: 'Días', value: 'Martes a sábado' },
      { label: 'Horario', value: '13:00–15:00' },
    ],
    rules: [
      { ok: true,  text: 'Indispensable saber nadar' },
      { ok: true,  text: 'Acceso por turnos, por orden de llegada' },
      { ok: true,  text: 'Permanecer sentado durante toda la actividad' },
      { ok: false, text: 'No ponerse de pie ni balancear la piragua' },
      { ok: false, text: 'No empujar ni chocar contra otras piraguas' },
    ],
    footer: 'Actividad dirigida y supervisada. Espera tu turno fuera del agua.',
  },
};
